export default __webpack_public_path__ + "static/media/like-icon.c0e1fe71.svg";